import { messagesNow } from '@/i18n'
import { messages } from './messages'

/**
 * Русский перевод серверных `error_code` на `failed`. Таблица, а не
 * одиночный `if`: жнец закрывает неотвеченный гейт как `failed` с
 * английской `"author did not answer in time"`, а `gate_resume_failed`
 * пришёл из работы про возобновление прогона — оба случая, где автор мог бы
 * прочитать нерусский текст на экране итога (тот рисуется НАД лентой, а не
 * вместо неё, — честное «пилоты всё равно оплачены» из карточки прогона
 * по-прежнему видно). Код без записи в таблице по-прежнему отдаёт
 * `errorMessage` (или сам код) как есть — это фолбэк, а не диагноз.
 *
 * Общая для итога прогона (`emptyRunReason.outcomeReason`) и снимка
 * родителя, который в реестр кладёт `useResumeJob` (§8, `JobEntry.previous`)
 * — второй копии таблицы быть не должно.
 */
const FAILED_ERROR_TEXT: Record<string, (m: (typeof messages)['ru']) => string> = {
  gate_expired: (m) => m.gateExpired,
  gate_resume_failed: (m) => m.gateResumeFailed,
  // Предохранитель бэка (§6.3): модель раз за разом ломала форму ответа, и
  // прогон остановлен, чтобы не жечь кредиты на заведомый брак.
  model_unusable: (m) => m.modelUnusable,
  // Курс опубликовали, пока шёл прогон: бэк писал в тело курса, а оно уже
  // живое — результат надо перезапускать, он уйдёт в черновик.
  course_went_live: (m) => m.courseWentLive,
}

export const failedReasonText = (
  errorCode: string | null,
  errorMessage: string | null,
): string | null => {
  const translated = errorCode ? FAILED_ERROR_TEXT[errorCode]?.(messagesNow(messages)) : undefined
  return translated ?? errorMessage ?? errorCode
}
